/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';

/**
 * 
 * @export
 * @interface ShipmentProjection
 */
export interface ShipmentProjection {
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof ShipmentProjection
     */
    invoiceNumber: HeoTransactionNumber;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProjection
     */
    service: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProjection
     */
    trackingNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentProjection
     */
    trackingLink: string;
    /**
     * 
     * @type {number}
     * @memberof ShipmentProjection
     */
    weight: number;
    /**
     * 
     * @type {Date}
     * @memberof ShipmentProjection
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ShipmentProjection interface.
 */
export function instanceOfShipmentProjection(value: object): value is ShipmentProjection {
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('service' in value) || value['service'] === undefined) return false;
    if (!('trackingNumber' in value) || value['trackingNumber'] === undefined) return false;
    if (!('trackingLink' in value) || value['trackingLink'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ShipmentProjectionFromJSON(json: any): ShipmentProjection {
    return ShipmentProjectionFromJSONTyped(json, false);
}

export function ShipmentProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceNumber': HeoTransactionNumberFromJSON(json['invoiceNumber']),
        'service': json['service'],
        'trackingNumber': json['trackingNumber'],
        'trackingLink': json['trackingLink'],
        'weight': json['weight'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ShipmentProjectionToJSON(json: any): ShipmentProjection {
    return ShipmentProjectionToJSONTyped(json, false);
}

export function ShipmentProjectionToJSONTyped(value?: ShipmentProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceNumber': HeoTransactionNumberToJSON(value['invoiceNumber']),
        'service': value['service'],
        'trackingNumber': value['trackingNumber'],
        'trackingLink': value['trackingLink'],
        'weight': value['weight'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

